import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  baseURL: "https://racedb.pesa.solutions/api/",
  //baseURL: "https://lbdb.pesa.solutions/api/",//not in use
  //baseURL: "http://localhost:3320/api/",
  //baseURL: "https://db.decawinrace.com/api/",
});

const writeAxiosInstance = axios.create({
  baseURL: "https://racedb.pesa.solutions/api/",
  //baseURL: "https://lbdb.pesa.solutions/api/",//not in use
  //baseURL: "http://localhost:3320/api/",
  //baseURL: "https://db.decawinrace.com/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;